import { Swiper } from './swiper-BHBZRieG.js';
import { A as A11y } from './a11y-BuXkunhH.js';
import { A as Autoplay } from './autoplay-DUKg3yoN.js';
import './utils-DCxzPGFN.js';

class AnnouncementBar extends HTMLElement {
  /** @type {import('swiper').Swiper | undefined} */
  #swiper;

  disconnectedCallback() {
    this.#swiper?.destroy(true, true);
    this.#swiper = undefined;
  }

  connectedCallback() {
    const el = this.querySelector('.swiper');
    if (!el || el.classList.contains('swiper-initialized')) return;

    const count = Number(this.dataset.uspCount || 0);
    if (count === 0) return;

    const delay = Number(this.dataset.autoplayDelay || 5000);

    this.#swiper = new Swiper(el, {
      modules: [A11y, Autoplay],
      slidesPerView: 1,
      spaceBetween: 0,
      centerInsufficientSlides: true,
      centeredSlides: true,
      watchOverflow: true,
      autoplay:
        count > 1
          ? {
              delay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
      rewind: count > 1,
      breakpoints: {
        768: {
          slidesPerView: count,
          spaceBetween: 20,
          centeredSlides: false,
          autoplay: false,
          rewind: false,
        },
      },
    });
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
}
